<template>
    <!--   -->
	<div id="formHeader" v-if="!isFromYjj">
		<div class="header" >
			<div class="leftIcon" @click="back">
				<i class="el-icon-arrow-left"></i>
			</div>
			<span>{{title}}</span>
		</div>
		<div class="mainFrame"  :class="{haveMargin:!isFromYjj}">
			<router-view/>
		</div>

	</div>
</template>

<script>
	export default {
		name: 'App',
		props:['title'],
        data() {
        	return {
                isFromYjj:'',
        	}
        }, //data end
		methods:{
			back(){
				this.$router.back()
			},
		},
        mounted(){
           this.isFromYjj=sessionStorage.getItem('isFromYjj')
           console.log(this.isFromYjj,'是否来自衣加加')
        }
	}
</script>

<style lang="less" scoped="scoped">
	body{background: #f7f7f7;}
	.header {
		position: fixed;
		top:0;
		right:0;left:0;
		padding:0.19rem;
        padding-top:0.59rem;
		background: #fff;
		font-size: 0.36rem;
		// background: #B22930;
		background: #fff;
		color:#333;
		text-align: center;
        font-weight: bold;
		z-index:1000;
        border-bottom: 1px solid #eee;
	}
	.mainFrame{
		margin-top:0rem ;
	}
    .haveMargin.mainFrame {
        margin-top: 1.2rem;
    }
	.leftIcon{color:#DE1D23; font-weight: bolder; position: absolute; font-size: 0.45rem;
    left:0rem;top:0.33rem; width: 1rem;line-height: 1rem;}
    .btn-long{font-size: 0.36rem;}
   
</style>


// WEBPACK FOOTER //
// src/page/formPage/formHeader.vue